
import wx from 'weixin-js-sdk'
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'

import api from '~api'
export default {
name: "checkin",
components: {
XHeader,Group,Selector,XInput,Toast,Actionsheet
},
computed:{
total(){
var tmp = 0;
for(var i = 0;i<this.feelist.length;i++){
tmp = parseFloat(tmp)+parseFloat(this.feelist[i].costFees);
}
tmp = parseFloat(tmp)-parseFloat(this.yjfee.costFees);
this.totalAll = parseFloat(tmp);
this.moneyNum = parseFloat(tmp);
return parseFloat(tmp);
},
totals(){
var tmp = this.totalAll;
if(this.apply1==1 && this.item1.applyStatus=='1'){
tmp = parseFloat(tmp)-parseFloat(this.item1.applyMoney);
}
if(this.apply2==1 && this.item2.applyStatus=='1'){
tmp = parseFloat(tmp)-parseFloat(this.item1.applyMoney);
}
if(this.apply3==1 && this.item3.applyStatus=='1'){
tmp = parseFloat(tmp)-parseFloat(this.item1.applyMoney);
}
return parseFloat(tmp);
},
countYj(){
var tmp = 0;
for(var key in this.arrearagelist){
tmp = parseFloat(tmp)+(parseFloat(this.arrearagelist[key].needFee)-parseFloat(this.arrearagelist[key].isFee));
}
return parseFloat(tmp);
}
},
data() {
return {
title: "缴费详情",
payDetail: [],
payWays: [],
clothesList: [],
showClothes: false,
feelist:[

],
stuinfo:{

},
totalAll: 0,
moneyNum: 0,
moneySum: 0,
lowestFee: 0,
showtoast:false,
toasttext:'',
welBool: true,
apply1:0,
item1:{},
apply2:0,
item2:{},
apply3:0,
item3:{},
arrearagelist: [],

feeYear: '',
yjfee: {},

jfBool: true,
menus1: {
wechatPay: "微信支付",
zgPay: "中国银行支付",
nyPay: "农业银行支付"
},
showBool: false
}
},
mounted(){
this.$http.post("http://yxxt.xijing.edu.cn:9088/mpmanageback/wx/pay/getPayParam",{"appid":"wxb3f0785d0cd6de69","url":"http://yxxt.xijing.edu.cn/xijng/onlinefee/"}).then(res =>{

if(res.status==200){
wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: res.data.result.appId, // 必填，公众号的唯一标识
timestamp: res.data.result.timestamp, // 必填，生成签名的时间戳
nonceStr: res.data.result.nonceStr, // 必填，生成签名的随机串
signature: res.data.result.signature,// 必填，签名，见附录1
jsApiList: ['chooseWXPay']
});

}
});
api.post("/api/NewReports/findInformation", {"stuCode": window.localStorage.getItem("stuCode")}).then( res=>{
if(res.status==200){
this.stuinfo = res.data.results[0];
if(this.stuinfo.gender=="1"){
this.$set(this.stuinfo,"sex","男")
}else{
this.$set(this.stuinfo,"sex","女")
}
}
})
this.getData();
this.getFee();
this.getClothes();
},
methods:{
subtractMoney(num1,num2){
var tmp = parseFloat(num1)-parseFloat(num2);
return parseFloat(tmp)
},
getClothes(){
console.log(777777)
let _this = this
api.post("/api/uniSele/selebystu", {"stuCode": window.localStorage.getItem('stuCode')}).then( res=>{
if(res.status==200){
if(res.data.data.length>0 ){
console.log(232342342,res.data.data)
_this.showClothes =true
_this.clothesList = res.data.data
}else {
_this.showClothes =false
}
}else {
_this.$msgbox('温馨提示：',"军训服服务器异常请稍后再试");
}
})
},
getFee(){
api.post("/api/fees/getCurrentChargeInfo", {"stuCode": window.localStorage.getItem("stuCode")}).then( res=>{
console.log(res)
if(res.status==200){
this.payWays = res.data.payWays;
this.payDetail = res.data.payDetail;
}else {
this.$msgbox('温馨提示：', "系统异常请稍后重试！");
}
})
},
getData(){
api.post("/api/fees/open", {"stuCode": window.localStorage.getItem("stuCode")}).then( res=>{
if(res.status==200){

this.arrearagelist = res.data.allFeeMsg;


this.feelist = res.data.feeList;

if(res.data.stuDorm!={} && res.data.stuDorm!=null){
this.feelist.push({
"costName": "住宿费",
"costFees": res.data.stuDorm.dormfeeprice
})
}

for(var key in this.arrearagelist){
if(key==res.data.findYear){
this.yjfee = {
"costName": "已缴金额",
"costFees": this.arrearagelist[key].isFee
};
}


if(key==res.data.findYear){
if((parseFloat(this.arrearagelist[key].needFee)-parseFloat(this.arrearagelist[key].isFee))<=0){
this.welBool = false;
}
}
}
this.lowestFee = res.data.lowestFee.lowestFee;
this.feeYear = res.data.findYear;


if(this.countYj<=0){
this.jfBool = false;
}

}
})








},
checkMoney(){
var numreg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
if(this.moneyNum == '' || this.moneyNum ==null){
this.toasttext = "请输入实缴金额";
this.showtoast=true;
return false;
}else if(!numreg.test(parseFloat(this.moneyNum)) || parseFloat(this.moneyNum)>this.total){
this.toasttext = "请输入正确的金额";
this.showtoast=true;
return false;
}else if(parseFloat(this.moneyNum)<parseFloat(this.lowestFee) && this.total>=parseFloat(this.lowestFee)){
this.toasttext = "缴费金额不得低于最低缴费标准：" +parseFloat(this.lowestFee)+ "元";
this.showtoast=true;
return false;
}
return true;
},
sortParam(obj){
var paramArr = [];
for(var o in obj){
paramArr.push(o +"="+ obj[o] +"&");
}
paramArr.sort();
var str = paramArr.join(":::").replace(/:::/g, "");
return str
},
canclepay(){
api.post("/payment/payCancel", {"stuCode": window.localStorage.getItem("stuCode")}).then( res=>{
if(res.status==200){
if(res.data.results=='1'){
if(window.localStorage.getItem('enrollType')==='1'){
this.$msgbox('温馨提示：', "您已取消该订单！");
}else {
this.$msgbox('温馨提示：', "您已取消该订单，请重新选择宿舍！");
}

this.$router.push({name: 'welcome'})
}else{
this.$msgbox('温馨提示：', "宿管系统异常，请联系管理员！");
this.$vux.loading.hide();
}
}
})

},
choosePay(){
this.showBool = true;
},
gotopay(key,item){
var _this = this;
if(key=="wechatPay"){
var obj = {
"channelPayWay":"JSAPI",

"amount":parseFloat(_this.moneyNum)*100+"",
"terminalCode":"TM20190614112332",
"device":"WEB",
"extra":
"{\"subOpenId\":\""+window.localStorage.getItem("openId")+"\"}",
"subject": _this.feeYear+"学费",
"body":_this.feeYear+"学杂费",
"stuCode":window.localStorage.getItem("stuCode"),
"stuNum":window.localStorage.getItem("stunum"),
"year": _this.feeYear,
"collection":"西京学院",
"majorId":window.localStorage.getItem("majorId")
};
if(this.checkMoney()){
api.post("/payment/pay",obj).then(res =>{
if(res.data!=null){
var params = {
"timeStamp": res.data.payParams.timeStamp,
"package": res.data.payParams.package,
"appId": "wxb3f0785d0cd6de69",
"signType": res.data.payParams.signType,
"nonceStr": res.data.payParams.nonceStr
};
var sign = _this.sortParam(params)+"key=wyyzxml88888mtdbq66666GoodSystem";
sign = _this.$md5(sign).toUpperCase();

wx.chooseWXPay({
timestamp: res.data.payParams.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
nonceStr: res.data.payParams.nonceStr, // 支付签名随机串，不长于 32 位
package: res.data.payParams.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
signType: res.data.payParams.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
paySign: sign, // 支付签名
success: function (res) {

_this.$msgbox('温馨提示：', "缴费成功！");
_this.$vux.loading.hide();
_this.getData()
},
cancel: function (res) {

_this.$msgbox('温馨提示：', "取消支付，缴费失败！");
_this.$vux.loading.hide();
},
error: function(res){

_this.$msgbox('温馨提示：', "缴费失败，请刷新后重试！");
_this.$vux.loading.hide();
}
});
}
});
}
}else if(key=="zgPay"){
_this.$msgbox('温馨提示：', "该功能暂未开放！");
}else{
_this.$msgbox('温馨提示：', "该功能暂未开放！");
}
},
gotohome(){
var _this = this;
this.$router.push({name: 'home'});
},
next(){
var _this = this;
var sort = _this.$route.params.sort;
var stunum = _this.$route.params.stunum;
_this.$router.push({name: 'pay',params:{sort:sort,stunum:stunum}});
},
delay(){
this.$msgbox('温馨提示：', "此项申请需到校现场办理！");



},
loan(){
var _this = this;
var stunum = _this.$route.params.stunum;
_this.$router.push({name:'loan',params:{stunum:stunum}})
},
reduce(){
this.$msgbox('温馨提示：', "此项申请需到校现场办理！");









},
reGet(){
this.$router.push({name: 'welcome'});
}
}
}



// WEBPACK FOOTER //
// ./src/components/newstu/checkin.vue